import { render, staticRenderFns } from "./SendMessages.vue?vue&type=template&id=33913a42&scoped=true"
import script from "./SendMessages.vue?vue&type=script&lang=js"
export * from "./SendMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33913a42",
  null
  
)

export default component.exports